import { initButter, startIntercom } from '@xbcb/ui-utils';
import { getIsHostCbms } from 'libs/getIsHostCbms';

export const initServices = (): void => {
  initButter();
  if (getIsHostCbms()) startIntercom();
};
